import { FallbackProps } from "react-error-boundary";
import { cn } from "@/core/helpers/cn";

interface ErrorFallbackProps extends FallbackProps {
  componentName?: string;
  showRetry?: boolean;
  showReload?: boolean;
  centered?: boolean;
}

export function ErrorFallback({
  error,
  resetErrorBoundary,
  componentName,
  centered = false,
  showRetry = true,
  showReload = false,
}: ErrorFallbackProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-center p-4 bg-dark-800/70 border border-red-900/50 rounded-lg",
        centered && "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
      )}
    >
      <div className="text-center">
        <div className="text-red-600 font-medium mb-2">
          {componentName ? `${componentName} failed` : "Something went wrong"}
        </div>

        <div className="text-gray-300 mb-3">{error.message || "An unexpected error occurred"}</div>

        <div className="flex gap-2 justify-center">
          {showRetry && (
            <button
              type="button"
              onClick={resetErrorBoundary}
              className="px-3 py-1 bg-red-600 hover:bg-red-700 text-white rounded transition-colors"
            >
              Retry
            </button>
          )}

          {showReload && (
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="px-3 py-1 bg-gray-600 hover:bg-gray-700 text-white rounded transition-colors"
            >
              Reload
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
